import PropTypes from 'prop-types';
import {withMemo} from 'helpers/wrapper';
import Debounce from 'components/organisms/Utils/Debounce/Debounce';
import {Navigate as NavigateBase} from 'react-router-dom';

const Navigate = withMemo((props) => {
  const {
    debounce,
    ...rest
  } = {
    debounce: true,
    ...props
  };

  return <Debounce frames={debounce === true ? 1 : 0}
                   timeout={(debounce && debounce !== true) ? debounce : 0}>
    <NavigateBase {...rest} />
  </Debounce>
})

Navigate.propTypes = {
  debounce: PropTypes.any
};

export default Navigate;
